const STORAGE_NAMES = Object.freeze({
    SEARCH_PARAMS: 'searchParams',
    CURRENT_TAB: 'currentTab'
});

export default STORAGE_NAMES;